import {Component, ViewEncapsulation} from '@angular/core';
import {CartService} from '../../../shared/services/cart.service';
import {InactivityService} from '../../../shared/services/inactivity.service';
import {ApiService} from '../../../shared/services/api.service';
import {NavigateService} from 'ngx-satoris';

@Component({
  selector: 'app-standby-desc-kiosk',
  templateUrl: './standby-desc-kiosk.component.html',
  styleUrl: './standby-desc-kiosk.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class StandbyDescKioskComponent {
  constructor(public cart: CartService, public nav: NavigateService, private inactivity: InactivityService, private api: ApiService) {
    const webKiosk = sessionStorage.getItem('webKiosk') === 'true';
    if(!this.inactivity.isWatching && this.api.userRole.isKiosk && !webKiosk) {
      this.inactivity.startWatching();
    }
    if(webKiosk) {
      this.nav.to('passport-type');
    }
  }
}
